import Moment from 'moment';

function ageValidator({ configs, input, msgs, params }) {
  const FORMAT = 'MM/DD/YYYY';
  const today = new Moment();
  let minAge = 18;
  let maxAge = 150;

  if (configs) {
    if (configs.OWNERSHIP) {
      if (configs.OWNERSHIP === 'PRIMARY') {
        minAge = configs.MINIMUM_AGE_PRIMARY ? parseFloat(configs.MINIMUM_AGE_PRIMARY) : 18;
        maxAge = configs.MAXIMUM_AGE_PRIMARY ? parseFloat(configs.MAXIMUM_AGE_PRIMARY) : 150;
      } else {
        minAge = configs.MINIMUM_AGE_SECONDARY ? parseFloat(configs.MINIMUM_AGE_SECONDARY) : 18;
        maxAge = configs.MAXIMUM_AGE_SECONDARY ? parseFloat(configs.MAXIMUM_AGE_SECONDARY) : 150;
      }
    } else {
      minAge = configs.MINIMUM_AGE ? parseFloat(configs.MINIMUM_AGE) : 18;
      maxAge = configs.MAXIMUM_AGE ? parseFloat(configs.MAXIMUM_AGE) : 150;
    }
  }

  if (params) {
    minAge = params.minAge ? params.minAge : minAge;
    maxAge = params.maxAge ? params.maxAge : maxAge;
  }

  const isValidFormat = Moment(input, FORMAT).format(FORMAT) === input;

  if (!isValidFormat) {
    return 'Invalid date.';
  }

  if (Moment(input, FORMAT) > today) {
    if (msgs && msgs.ageToYoung) {
      return msgs.ageInFuture;
    }
    return 'Please enter a valid date of birth. It cannot be in the future.';
  }

  if (
    minAge &&
    new Moment(input, FORMAT).isAfter(new Moment().startOf('day').subtract(minAge, 'years'))
  ) {
    if (msgs && msgs.ageToYoung) {
      return msgs.ageToYoung.replace('%s', minAge);
    }
    return 'Please enter a valid date of birth. You must be at least %s years old to apply.'.replace(
      '%s',
      minAge,
    );
  }

  if (
    maxAge &&
    new Moment(input, FORMAT).isBefore(new Moment().startOf('day').subtract(maxAge, 'years'))
  ) {
    if (msgs && msgs.ageToOld) {
      return msgs.ageToOld.replace('%s', maxAge);
    }
    return 'Please enter a valid date of birth. You must be under %s years old to apply.'.replace(
      '%s',
      maxAge,
    );
  }

  return null;
}

export default ageValidator;
